import React, { useState, useEffect } from "react";
import BasicInfoForm from "./BasicInfoForm";
import useAxios from "axios-hooks";
import { Spinner } from "@fluentui/react";
import { useParams, useRouteMatch, useLocation, useHistory } from "react-router-dom";
import Toast from "../../../../Forms/Toast";
import FeatureSummary from "../../../../Util/FeatureSummary";

const BasicInfoPage = () => {
  const { url } = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  let { actionItemId } = useParams();
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("Saved!");

  // Check for saved query param to show toast after create
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('saved') === 'true') {
      setToastMessage("Action item created!");
      setShowToast(true);
      // Remove the query param from URL without reload
      history.replace(location.pathname);
    }
  }, [location.search, location.pathname, history]);

  // eslint-disable-next-line no-empty-pattern
  const [{}, postForm] = useAxios(
    { url: `action-item/${actionItemId || ""}` },
    { manual: true }
  );

  const [
    { data: actionItemData, loading: getActionItemLoading },
    executeGetActionItem,
  ] = useAxios(
    { url: `action-item/${actionItemId}`, method: "get" },
    { manual: true }
  );

  if (actionItemId && !actionItemData && !getActionItemLoading) {
    executeGetActionItem();
  }

  if (getActionItemLoading) {
    return <Spinner className="absolute-center" label="Loading..." />;
  }

  const onCreateSuccess = (newActionItemId) => {
    // Navigate to the edit page with saved=true to show toast
    const basePath = url.replace('/basic-info', '');
    window.location.href = `${basePath}/${newActionItemId}/basic-info?saved=true`;
  };

  const onUpdateSuccess = () => {
    setToastMessage("Saved!");
    setShowToast(true);
  };

  return (
    <div>
      <BasicInfoForm 
        postForm={postForm} 
        actionItemData={actionItemData}
        onCreateSuccess={onCreateSuccess}
        onUpdateSuccess={onUpdateSuccess}
      />
      <Toast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />
      <FeatureSummary
        label="About Action Items"
        summary="Create or edit action items that can be added to checklists. Configure the item title, description, type, URL, icon, and other properties. Action items represent individual tasks or steps that users complete within a checklist."
      />
    </div>
  );
};

export default BasicInfoPage;
